import {useContext} from "react";
import {
  GlobalAppStateContextInterface,
} from "../../services/exports/Interfaces";
import AppStateContext from "../../context/AppStateContext";

export default function useAppState(): GlobalAppStateContextInterface {
  return useContext(AppStateContext).state;
}
